import * as constAction from 'root/actionConstants';

export const get = () => ({
  type: constAction.REGISTROS_GET,
  epic: {
    url: 'alertas/empleado',
    method: 'GET',
  },
});

export const getLogs = (fecha, skip = 0 ) => ({
  type: constAction.REGISTROS_GET_LOGS,
  payload: {
    filter: {
      where: { fecha: { between: [fecha.startOf('day').toDate(), fecha.endOf('day').toDate()] } },
      skip
    }
  },
  epic: {
    url: 'alertas/getLogs',
    method: 'GET',
  },
});

export const concatState = response => ({
  type: constAction.REGISTROS_LOGS_CONCAT_STATE,
  payload: response
});

export const getUserById = id => ({
  type: constAction.REGISTROS_USER_BY_ID,
  payload: {
    filter: {
      fields: ['nombre', 'apellido','id']
    }
  },
  epic: {
    url: 'usuarios/'+id,
    method: 'GET'
  }
});

export const filterLogsByAction = action => ({
  type: constAction.REGISTROS_FILTER_BYACTION,
  payload: action
});

export const setUserState = payload => ({
  type: constAction.REGISTROS_USER_SET_STATE,
  payload: payload
});

export const clear = value => ({
  type: constAction.REGISTROS_CLEAR,
  payload: value
});

export const setState = payload => ({
  type: constAction.REGISTROS_SET_STATE,
  payload: payload
});



// WEBPACK FOOTER //
// src/modules/registros/action.js